import {SaleSummaryModel} from './saleSummary.model';
import {SaleProductSummaryModel} from "../../modules/product/api/entity/saleProductSummary.model";

export class SaleModel {
    summary: SaleSummaryModel;
    comment: string;
    remainingAmountToRequest: 0;
    products: SaleProductSummaryModel[] = [];
}

export enum SALE_DIRECTION {
    SALE_DIRECTION_OUT = 'SALE_DIRECTION_OUT',
    SALE_DIRECTION_IN = 'SALE_DIRECTION_IN'
}

export enum SALE_STATUS {
    SALE_STATUS_CREATED = 'SALE_STATUS_CREATED',
    SALE_STATUS_ACCEPTED = 'SALE_STATUS_ACCEPTED',
    SALE_STATUS_DELIVERY_IN_PROGRESS = 'SALE_STATUS_DELIVERY_IN_PROGRESS',
    SALE_STATUS_COMPLETED = 'SALE_STATUS_COMPLETED',
    SALE_STATUS_WAITING_CONFIRMATION = 'SALE_STATUS_WAITING_CONFIRMATION',
    SALE_STATUS_REFUSED = 'SALE_STATUS_REFUSED',
    SALE_STATUS_CANCELLED = 'SALE_STATUS_CANCELLED',
}
